// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__CVJEM","modal":"Modal_modal__MfqQO","show":"Modal_show__ZhELm","hide":"Modal_hide__jazQq"};